import React from 'react';
import { Zap } from 'lucide-react';
import DataSection from '../dataSections/DataSection';

export default function Apify() {
  return (
    <DataSection
      title="APIFY"
      icon={Zap}
      contentType="apify"
      executionUrlSuffix="apify"
      isComplex
    />
  );
}

